import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgrupacionnovedadesComponent } from './components/agrupacionnovedades/agrupacionnovedades.component';

const routes: Routes = [
  { path: 'agrupacionnovedades', component: AgrupacionnovedadesComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgrupacionnovedadesRoutingModule { }
